import router from '@/router'
const state = {
	isLogged: window.localStorage.getItem('token')
}

const getters = {
	isUserLoggedIn (state) {
		return item => state.isLogged === item
	}
}

const mutations = {
	userLogIn (state) {
		state.isLogged = true
	},
	userLogOut (state) {
		state.isLogged = false
		window.localStorage.removeItem('token')
		router.push('/')
	}
}

export default {
	state,
	mutations,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js